import { getRegionFromPath } from './getRegionFromPath';

export const getNavigationUrl = (to: string, appRegion?: string): string => {
  if (to.startsWith('^/')) {
    return to.slice(1);
  }

  if (!appRegion || !to.startsWith('/')) {
    return to;
  }

  const splittedUrl = to.split('/');
  if (splittedUrl.length > 1 && getRegionFromPath(splittedUrl[1])) {
    return to;
  }

  return `/${appRegion.slice('crowdaa-'.length)}${to}`;
};
